// api/userApi.ts
import { baseApi } from "./BaseApi";
import { User, UserCompany, WaitingListEntry } from "../types/commonTypes";

const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // todo: delete this and move to admin api
    fetchAllUsers: builder.query<User[], void>({
      query: () => `/_admin/users`,
    }),
    createUserCompany: builder.mutation<
      UserCompany,
      { userId: string; companyId: number }
    >({
      query: (data) => ({
        url: `/_admin/user-companies`,
        method: "POST",
        body: data,
      }),
    }),
    sendUserPhoneVerification: builder.mutation<void, { accessToken: string }>({
      query: (data) => ({
        url: `/user/verify/number`,
        method: "POST",
        body: data,
      }),
    }),
    addUserToWaitingList: builder.mutation<
      void,
      { email: string; name?: string }
    >({
      query: (data) => ({
        url: `/user/waiting-list`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useFetchAllUsersQuery,
  useCreateUserCompanyMutation,
  useSendUserPhoneVerificationMutation,
  useAddUserToWaitingListMutation,
} = userApi;

export default userApi;
